export const getUetDashboardSummaryBarStyle = () => ({
  '@global': {
    '.summary-bar-items > div': {
      '& > div:nth-child(2)': {
        minHeight: '0px !important',
      },
      '& .edit-icon': {
        display: 'flex',
        alignItems: 'center',
      },
      '& .entity-label': {
        padding: '0px !important',
      },
      '& .edit-icon .web-insights': {
        marginRight: '8px',
      },
      '& .edit-icon .glyphicon-pencil': {
        fontSize: '16px',
        opacity: 0,
        transition: 'opacity 0.3s ease',
      },
      '&:hover, &:active, &:focus': {
        background: 'transparent !important',
        '& .edit-icon .glyphicon-pencil': {
          opacity: 1,
        },
      },
    },
  },
});
